import {
  Box,
  Button,
  Icon,
  IconButton,
  Link,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import C from '../../../../../shared/constants/general';
import UserAvatar from '../ui/UserAvatar';
import { Anchorme } from 'react-anchorme';

const useStyles = makeStyles((theme) => ({
  selfMargins: {
    marginBottom: '0.7rem',
    paddingLeft: '5rem',
  },
  margins: {
    marginBottom: '0.7rem',
    paddingRight: '2rem',
  },
  avatar: {},
  avatarButton: {
    padding: 10,
  },
  textFormat: {
    whiteSpace: 'pre-wrap',
  },
  userNameHolder: {
    height: 17,
    lineHeight: '13px',
  },
  userName: {
    textDecoration: 'underline',
    textTransform: 'capitalize',
    fontSize: 10,
    padding: 0,
    height: 17,
    color: theme.palette.text.secondary,
    opacity: 0.5,
    '&:hover': {
      opacity: 1,
      textDecoration: 'underline',
    },
  },
  userNameStar: {
    fontSize: 12,
    width: 10,
    height: 10,
  },
  chatHolder: {
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
  },
  chatText: {
    position: 'relative',
    backgroundColor: theme.palette.background.shadedown_10,
    borderRadius: '1rem',
    borderBottomLeftRadius: '0',
    padding: '1rem',
  },
  selfChatText: {
    width: '100%',
    overflowX: 'auto',
    position: 'relative',
    backgroundColor: theme.palette.background.shadedown_10,
    borderRadius: '1rem',
    borderBottomRightRadius: '0',
    padding: '1rem',
    marginRight: 5,
  },
  removedText: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  editButton: {
    position: 'absolute',
    right: 0,
    top: 3,
    height: 15,
    minWidth: 25,
  },
  editIcon: {
    marginTop: -10,
    color: theme.palette.text.secondary,
  },
  pinned: {
    position: 'absolute',
    right: 0,
    top: 20,
    height: 15,
    minWidth: 20,
    fontSize: 13,
  },
}));

const shouldReRender = function (prevProps, nextProps) {
  return (
    nextProps.tempText ||
    prevProps.message.content.text === nextProps.message.content.text
  );
};

const ChatBubble = (props) => {
  const classes = useStyles();

  const isContributer =
    !props.tempText &&
    props.message.visitor &&
    props.message.visitor.participation_level ===
      C.VISITOR.PARTICIPATION_LEVEL.CONTRIBUTE;

  return props.tempText ? (
    <Box className={classes.selfMargins}>
      <Box display="flex" alignItems="flex-end">
        <Box className={classes.selfChatText} flexGrow={1}>
          <Typography variant="body1" className={classes.textFormat}>
            {props.tempText}
          </Typography>
        </Box>
      </Box>
    </Box>
  ) : props.message.visitor && props.message.visitor.id === props.user.id ? (
    <Box className={classes.selfMargins}>
      <Box display="flex" alignItems="flex-end">
        {props.message.content.text ? (
          <Box className={classes.selfChatText} flexGrow={1}>
            {!props.socketMessage && props.moderate && (
              <Button
                onClick={() => {
                  props.moderate(
                    props.message.id,
                    props.message.content.text,
                    true
                  );
                }}
                className={classes.editButton}
              >
                <Icon className={classes.editIcon}>more_horiz</Icon>
              </Button>
            )}

            {(isContributer || props.canModerate) &&
              props.message.pinned > 0 && (
                <Icon className={classes.pinned}>push_pin</Icon>
              )}

            <Typography variant="body1" className={classes.textFormat}>
              <Anchorme
                truncate={20}
                linkComponent={Link}
                target="_blank"
                rel="noreferrer noopener"
              >
                {props.message.content.text}
              </Anchorme>
            </Typography>
          </Box>
        ) : (
          <Box px={2} py={0} align="right">
            <Typography variant="body1" className={classes.removedText}>
              {props.message.content.reason}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  ) : (
    <Box className={classes.margins}>
      <Box display="flex" alignItems="flex-end">
        {props.message.content.text ? (
          <React.Fragment>
            <Box>
              {props.message.visitor ? (
                <IconButton
                  className={classes.avatarButton}
                  onClick={() => props.userPopup(props.message.visitor)}
                >
                  <UserAvatar size="small" user={props.message.visitor} />
                </IconButton>
              ) : (
                <IconButton className={classes.avatarButton} disabled={true}>
                  <UserAvatar size="small" user={null} />
                </IconButton>
              )}
            </Box>
            <Box flexGrow={1} className={classes.chatHolder}>
              <Box className={classes.chatText}>
                {props.canModerate && (
                  <Button
                    onClick={() => {
                      props.moderate(
                        props.message.id,
                        props.message.content.text,
                        false
                      );
                    }}
                    className={classes.editButton}
                  >
                    <Icon className={classes.editIcon}>more_horiz</Icon>
                  </Button>
                )}

                {(isContributer || props.canModerate) &&
                  props.message.pinned > 0 && (
                    <Icon className={classes.pinned}>push_pin</Icon>
                  )}
                <Typography variant="body1" className={classes.textFormat}>
                  <Anchorme
                    truncate={20}
                    linkComponent={Link}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {props.message.content.text}
                  </Anchorme>
                </Typography>
              </Box>
              <Box className={classes.userNameHolder}>
                {props.message.visitor ? (
                  <>
                    <Button
                      className={classes.userName}
                      component="a"
                      onClick={() => props.userPopup(props.message.visitor)}
                    >
                      {props.message.visitor.full_name}
                    </Button>
                    {isContributer && (
                      <Icon color="primary" className={classes.userNameStar}>
                        star
                      </Icon>
                    )}
                  </>
                ) : (
                  <Typography variant="body1" className={classes.removedText}>
                    User no longer exist
                  </Typography>
                )}
              </Box>
            </Box>
          </React.Fragment>
        ) : (
          <Box px={2} py={0}>
            <Typography variant="body1" className={classes.removedText}>
              {props.message.content.reason}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default React.memo(ChatBubble, shouldReRender);
